import { Routes, Route } from "react-router-dom";
import React, {  } from "react";
import TopBar from "../components/pages/layout/TopBar";
import Pendingtask from "../components/pages/mypendingtask/Pendingtask";
import Teamtraining from "../components/pages/mytrainings/Teamtraining";
import UpcomingTainings from "../components/pages/upcomingtrainings/upcomingtrainings";
import Home from "../components/pages/home/home";
import CourseCatalog from "../components/pages/coursecatalogue/CourseCatalog";
import Vendors from '../components/pages/vendors/Vendors';
import Category1 from "../components/pages/masterdata/Category1";
import Category2 from "../components/pages/masterdata/Category2";
import Skills from "../components/pages/masterdata/Skills";
import CommitteeRoles from "../components/pages/masterdata/CommitteeRole";
import SkillMatrix from "../components/pages/skillmatrix/SkillMatrix";
import SkillOverview from "../components/pages/skilloverview/SkillOverview";
import Level from "../components/pages/masterdata/Level";
import Mainroles from "../components/pages/masterdata/Mainroles";
import TeamSkillChart from "../components/pages/myteam/TeamSkillChart";
import CourseMaster from "../components/pages/masterdata/CourseMaster";
import RequestStatus from "../components/pages/requeststatus/requeststatus";
import TrainingRecords from "../components/pages/trainingrecords/trainingrecords";
import UserNotFound from "../components/pages/userNotFound";
import SessionExpired from "../components/pages/sessionExpired";
import Login from "../Login";
import axios from "axios";
import Role from "../components/helpers/role";
import withRouter from "../components/custom/withRouter";
import { connect } from "react-redux";
import Skillproficiencyduration from "../components/pages/skillproficiencyduration/skillproficiencyduration";
import CompetencyGrading from "../components/pages/myteam/CompetencyGrading";


class Routing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      showTopBar : false,
      userRole : "",
      userId : 0
    }
  }
  componentDidUpdate() {

    if(this.state.userId !== localStorage.getItem("userId")){
      this.setState({userId : localStorage.getItem("userId")})
    const userDetails = localStorage.getItem("userData");
    let role = localStorage.getItem("Role");
    this.state.userRole = role?.split(",")[0]
    let userToken = JSON.parse(userDetails);
    if (userToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${userToken.id_token}`;
    }
  }
  }

  componentDidMount() {

    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }


  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    this.setState({})
  }
  
  componentWillMount() {
    axios.interceptors.request.use(
      (config) => {
        const userDetails = localStorage.getItem("userData");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.id_token;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  }

  render(){
    const { menuToggle } = this.props;
    return (
          <>
            {(window.location.pathname == "/usernotfound" || window.location.pathname == "/sessionexpired") ? "" :
            window.location.pathname !== "/" && (
              // <div className={this.state.isMobile === true ? "" : menuToggle ? "main-sidebar-toggle" : "main-sidebar"}>
              <div className={this.state.isMobile === true ? "" : menuToggle ? "main-sidebar-toggle" : "main-sidebar"}>
                <TopBar />
              </div>
            )}
            {/* <TopBar /> */}
      
              <Routes>
                {/* <Route exact path="/" element={<Navigate to={"/home"} />} /> */}
                
                <Route exact path="/" element={<Login />} />
                <Route path="/home" element={<Home />} />
                <Route path="/mypendingtask" element={<Pendingtask />} />
                {/* <Route path="/mytrainings" element={<Training />} /> */}
                <Route path="/coursecatalouge" element={<CourseCatalog />} />
                <Route path="/skillmatrix" element={<SkillMatrix />} />
                <Route path="/trainingcalender" element={<UpcomingTainings />} />
                <Route path="/requeststatus" element={<RequestStatus />} />
                <Route path="/usernotfound" element={<UserNotFound />} />
                <Route path="/sessionexpired" element={<SessionExpired />} />
      
                { this.state.userRole !== Role.EMPLOYEE &&
                <>
                {/* <Route path="/mypendingapprovals" element={<PendingSubmissions />} /> */}
                {/* <Route path="/mypendingsubmissions" element={<PendingSubmissions />} /> */}
                <Route path="/upcomingtrainings" element={<UpcomingTainings />} />
                {/* <Route path="/myteam" element={<MyTeam />} /> */}
                <Route path="/vendors" element={<Vendors />} />
                {/* <Route path="/coursequestionnaire" element={<CourseQuestionnaire />} /> */}
                <Route path="/category1" element={<Category1 />} />
                <Route path="/category2" element={<Category2 />} />
                <Route path="/skills" element={<Skills />} />
                {/* <Route path="/jobs" element={<Jobs />} /> */}
                {/* <Route path="/skills_jobs" element={<SkillsJobs />} /> */}
                <Route path="/committee_roles" element={<CommitteeRoles />} />
                <Route path="/skilloverview" element={<SkillOverview />} />
                <Route path="/teamstrainings" element={<Teamtraining />} />
                <Route path="/competencygrading" element={<CompetencyGrading />} />
                <Route path="/level" element={<Level />} />
                {/* <Route path="/proficiency" element={<Proficiency />} /> */}
                <Route path="/mainroles" element={<Mainroles />} />
                {/* <Route path="/letterofundertaking" element={<Lou />} /> */}
                <Route path="/teamskillchart" element={<TeamSkillChart />} />
                <Route path="/coursemaster" element={<CourseMaster />} />
                <Route path="/trainingrecord" element={<TrainingRecords />} />
                <Route path="/skillproficiencyduration" element={<Skillproficiencyduration/>} />
                </>
                }
              </Routes>
            </>
          );
  }
  }

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Routing));

















// const Routing = () => {
//   const [showTopBar, setShowTopBar] = useState(false);
//   const location = useLocation();
//   const userRole = localStorage.getItem("Role")
  
//   useEffect(() => {
//     const { pathname } = location;
//     const showTopBar = pathname !== "/";
//     setShowTopBar(showTopBar);
    
//   }, [location]);

//   useEffect(() => {
//     const userDetails = localStorage.getItem("userData");
//     let userToken = JSON.parse(userDetails);
//     if (userToken) {
//       axios.defaults.headers.common['Authorization'] = `Bearer ${userToken.id_token}`;
//     }
//   },[])

//   return (
//     <>
//       {showTopBar && <TopBar />}

//         <Routes>
//           {/* <Route exact path="/" element={<Navigate to={"/home"} />} /> */}
          
//           <Route exact path="/" element={<Login />} />
//           <Route path="/home" element={<Home />} />
//           <Route path="/mypendingtask" element={<Pendingtask />} />
//           <Route path="/mytrainings" element={<Training />} />
//           <Route path="/coursecatalouge" element={<CourseCatalog />} />
//           <Route path="/skillmatrix" element={<SkillMatrix />} />
//           <Route path="/trainingcalender" element={<UpcomingTainings />} />

//           { userRole !== Role.EMPLOYEE &&
//           <>
//           {/* <Route path="/mypendingapprovals" element={<PendingSubmissions />} /> */}
//           {/* <Route path="/mypendingsubmissions" element={<PendingSubmissions />} /> */}
//           <Route path="/upcomingtrainings" element={<UpcomingTainings />} />
//           {/* <Route path="/myteam" element={<MyTeam />} /> */}
//           <Route path="/pte" element={<PTE />} />
//           <Route path="/vendors" element={<Vendors />} />
//           {/* <Route path="/coursequestionnaire" element={<CourseQuestionnaire />} /> */}
//           <Route path="/category1" element={<Category1 />} />
//           <Route path="/category2" element={<Category2 />} />
//           <Route path="/skills" element={<Skills />} />
//           {/* <Route path="/jobs" element={<Jobs />} /> */}
//           {/* <Route path="/skills_jobs" element={<SkillsJobs />} /> */}
//           <Route path="/committee_roles" element={<CommitteeRoles />} />
//           <Route path="/skilloverview" element={<SkillOverview />} />
//           <Route path="/teamstrainings" element={<Teamtraining />} />
//           <Route path="/level" element={<Level />} />
//           {/* <Route path="/proficiency" element={<Proficiency />} /> */}
//           <Route path="/mainroles" element={<Mainroles />} />
//           {/* <Route path="/letterofundertaking" element={<Lou />} /> */}
//           <Route path="/teamskillchart" element={<TeamSkillChart />} />
//           <Route path="/coursemaster" element={<CourseMaster />} />
//           <Route path="/requeststatus" element={<RequestStatus />} />
//           <Route path="/trainingrecord" element={<TrainingRecords />} />
//           <Route path="/usernotfound" element={<UserNotFound />} />
//           </>
//           }
//         </Routes>
//       </>
//     );
// }
// export default Routing;